import { Link } from "react-router-dom";
import type { Business } from "@/types";
import BusinessCard from "@/components/feature/BusinessCard";

export default function SponsoredBusinesses({ businesses }: { businesses: Business[] }) {
  if (businesses.length === 0) return null;
  return (
    <section className="border-y border-background-900 bg-gradient-to-br from-foreground-950 via-foreground-900 to-foreground-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-foreground-950">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-megaphone-line text-sm"></i>
              </span>
              Sponsored
            </span>
            <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
              Sponsored businesses on Mysore
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-base">
              Local businesses that booked a sponsored placement to get seen first. Every sponsored
              listing is clearly labelled, and relevance is never overridden.
            </p>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/20 bg-background-50/10 px-4 py-2 text-sm font-semibold text-background-50">
              <span className="flex h-4 w-4 items-center justify-center text-primary-400">
                <i className="ri-star-smile-line text-sm"></i>
              </span>
              {businesses.length} sponsored spots
            </span>
            <Link
              to="/listing-plans"
              className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors duration-200 hover:bg-primary-400 cursor-pointer"
            >
              Advertise here
              <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5"></i>
            </Link>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {businesses.slice(0, 8).map((b) => (
            <BusinessCard key={b.id} business={b} badge="sponsored" />
          ))}
        </div>
      </div>
    </section>
  );
}